import axiosInstance from "../Interceptors/axiosInstance.jsx";
import Cookies from "js-cookie";

const getMultipartHeaders = () => ({
  "Content-Type": "multipart/form-data",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
});

const headers = {
  accept: "*/*",
  Authorization: `Bearer ${Cookies.get("accessToken")}`,
  "Content-Type": "application/json",
};

export const getContentsList = async () => {
  return await axiosInstance.get("contents/getlist", { headers });
};

/**
 * Contents for section-mapping modal (and future filters).
 * Swap implementation to contents/search when API is available.
 */
export const fetchContentsForMapping = async (params = {}) => {
  if (params.searchEndpoint) {
    return await axiosInstance.get(params.searchEndpoint, {
      headers,
      params: params.query,
    });
  }
  return await getContentsList();
};

export const getContentById = async (id) => {
  const response = await axiosInstance.get(`contents/get/${id}`, { headers });
  return response.data.result;
};

export const addContent = async (formData) => {
  return await axiosInstance.post("contents/add", formData, {
    headers: getMultipartHeaders(),
  });
};

export const updateContent = async (formData) => {
  return await axiosInstance.put("contents/update", formData, {
    headers: getMultipartHeaders(),
  });
};

export const deleteContent = async (id) => {
  return await axiosInstance.delete(`contents/delete/${id}`, { headers });
};
